export default __webpack_public_path__ + "static/media/nft-purple.b0b5bd39.svg";